import { createApp, provide, h } from 'vue';
import { createPinia } from 'pinia';
import router from '@router/router';
import App from './App.vue';
import PtUI from '@ui/index';
import PtUIV1 from '@uiv1/index';
import i18n from '@assets/i18n/index';
import { ApolloClients, provideApolloClient } from '@vue/apollo-composable';
import PtComponentVue3 from 'pt-component-vue3';
import '@apis/http.interceptor';
import '@uiv1/styles/theme-ptx/index.scss';
import '@style/base.scss';
import '@style/main.scss';
import VueClipBoard from 'vue3-clipboard';
import store from '@store';
import Directives from '@assets/directives';
import ErrorPlugin from '@assets/plugins/error.plugin';
import { toThousand, toDecimal2 } from '@utils/common.util';
import dateUtils from '@utils/date.utils';
import apolloClient from '@/graphql/apollo-client';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

const app = createApp({
    setup() {
        provide(ApolloClients, {
            default: provideApolloClient(apolloClient as any)
        });
    },
    render: () => h(App)
});

const dsn = import.meta.env.VITE_SENTRY_DSN as string;
if (dsn) {
    // Sentry.init({
    //     app,
    //     dsn,
    //     //添加后导致pti进入报错
    //     // integrations: [
    //     // new BrowserTracing({
    //     //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //     //     tracingOrigins: ['localhost', 'my-site-url.com', /^\//]
    //     // })
    //     // ],
    //     tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as unknown as number
    // });
}

Directives.map(directive => {
    app.directive(directive.name, directive);
});

app.use(createPinia())
    .use(router)
    .use(PtUI)
    .use(PtUIV1)
    .use(PtComponentVue3)
    .use(VueClipBoard, {
        autoSetContainer: true,
        appendToBody: true
    })
    .use(store)
    .use(i18n)
    .use(ErrorPlugin)
    .mount('#app');

app.config.globalProperties.$filters = {
    toThousand: toThousand,
    toDecimal2: toDecimal2,
    getDuration: dateUtils.getDuration
};
